<template>
	<div>
		<template v-for="(content, i) in componentItem.content">
			<div :key="i">
				<div>
					<div v-if="i === 'video-src'">
						<h5>Video source</h5>
						<VideoUploader @file-added="updateFileNames" />
						<template slot="title">
							<label>mobile</label>
						</template>
						<div class="form-group">
							<label>mobile</label>
							<input disabled type="text" class="form-control" v-model="componentItem.content[i]['mobile']" >
						</div>
						<div class="form-group">
							<label>tablet</label>
							<input disabled type="text" class="form-control" v-model="componentItem.content[i]['tablet']" >
						</div>
						<div class="form-group">
							<label>desktop</label>
							<input disabled type="text" class="form-control" v-model="componentItem.content[i]['desktop']" >
						</div>
					</div>
					<div v-if="i === 'background-image'">
						<BackgroundImage :backgroundImage="componentItem.content[i]" :forTemplate="componentItem.template" />
					</div>
					
					<div v-if="i === 'ad-preroll' && hasPrerollTag" class="border p-2 m-1">
						<div>
							<div class="form-group">
								<label>Ad tag</label>
								<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]['ad-tag']" >
							</div>
							<div class="form-group">
								<label>Keyword</label>
								<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]['keywords'][0]" >
							</div>
							<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="removeAdTag">
								<img src="~@/assets/icons/minus.svg">
							</button>
						</div>
					</div>

					<div v-else-if="typeof content !== 'object'" class="form-group">
						<label>{{ i }}</label>
						<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]" >
					</div>
				</div>
			</div>
		</template>
		<div v-if="!hasPrerollTag">
			<div class="form-group">
				<label>Add preroll tag</label>
					<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="addAdTag">
					<img src="~@/assets/icons/add.svg">
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import BackgroundImage from '../BackgroundImage';
	import VideoUploader from '../VideoUploader';

	export default {

		components: {
			BackgroundImage,
			VideoUploader
		},		

		methods: {
			updateFileNames:function(fileName){
				var extension = "mp4"
				var filenameWithoutExtension = fileName.split('.').slice(0, -1).join('.')
				this.componentItem.content['video-src']['mobile'] = filenameWithoutExtension + "-mobile." + extension
				this.componentItem.content['video-src']['tablet'] = filenameWithoutExtension + "-tablet." + extension
				this.componentItem.content['video-src']['desktop'] = filenameWithoutExtension + "-desktop." + extension
			},
			addAdTag:function(){
				this.componentItem.content['ad-preroll'] = this.getAdTagTemplate();
				this.hasPrerollTag = true;
			},
			removeAdTag:function(){
				delete this.componentItem.content['ad-preroll']
				this.hasPrerollTag = false;
			},
			getAdTagTemplate(){
				return JSON.parse(JSON.stringify(
					this.componentTemplates.filter(item => item.template == 'video')[0].content['ad-preroll']
				))
			}
		},

		data() {
			return {
				hasPrerollTag: false
			}
		},

		mounted() {
			if(this.componentItem.content['ad-preroll']) {
				this.hasPrerollTag = true;
			}
		},

		name: 'Video',
		
		props: ['componentItem', 'index', 'componentTemplates'],

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}

</style>